import { render, staticRenderFns } from "./pendingIncomeConfirmation.vue?vue&type=template&id=0f5d46d0&scoped=true"
import script from "./pendingIncomeConfirmation.vue?vue&type=script&lang=js"
export * from "./pendingIncomeConfirmation.vue?vue&type=script&lang=js"
import style0 from "./pendingIncomeConfirmation.vue?vue&type=style&index=0&id=0f5d46d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5d46d0",
  null
  
)

export default component.exports